export const EDITOR_OPTIONS = {
  baseUrl: 'form-builder',
  theme: 'vs-dark',
  language: 'json',
  minimap: {
    enabled: false
  },
  lineNumbers: 'off',
  scrollBeyondLastLine: false,
  automaticLayout: true
};
